import { Package, Truck } from "lucide-react";
import { Progress } from "@/components/ui/progress";
import { useShippingSettings } from "@/hooks/useSiteSettings";

interface ShippingProgressProps {
  currentTotal: number;
  threshold?: number;
}

export const ShippingProgress = ({ currentTotal, threshold }: ShippingProgressProps) => {
  const { free_shipping_threshold } = useShippingSettings();
  const effectiveThreshold = threshold ?? free_shipping_threshold;
  return <ShippingProgressInner currentTotal={currentTotal} threshold={effectiveThreshold} />;
};

const ShippingProgressInner = ({ currentTotal, threshold }: { currentTotal: number; threshold: number }) => {
  const remaining = threshold - currentTotal;
  const progress = Math.min((currentTotal / threshold) * 100, 100);
  const isQualified = currentTotal >= threshold;

  return (
    <div className="bg-gradient-to-r from-solr-nebula-purple/10 to-solr-cosmic-teal/10 border border-solr-nebula-purple/20 rounded-lg p-4 mb-6">
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center gap-2">
          {isQualified ? (
            <Truck className="h-5 w-5 text-solr-cosmic-teal" />
          ) : (
            <Package className="h-5 w-5 text-solr-nebula-purple" />
          )}
          <span className="font-semibold text-solr-text-primary">
            {isQualified ? "Free Shipping Unlocked! 🎉" : "Free Shipping"}
          </span>
        </div>
        <span className="text-sm text-solr-text-secondary">
          {isQualified ? "Qualified" : `£${remaining.toFixed(2)} to go`}
        </span>
      </div>
      <Progress value={progress} className="h-2 mb-2" />
      <p className="text-xs text-solr-text-secondary">
        {isQualified 
          ? "Your order qualifies for free shipping"
          : `Add £${remaining.toFixed(2)} more to get free shipping`
        }
      </p>
    </div>
  );
};
